<template>
  <div v-zpm="{ sectionid: 116 }" class="new-qc-report-detail">
    <!-- 质检项 -->
    <template v-for="(tab, tabIndex) in dataInfo.report.reportItem">
      <qc-report-tab
        v-if="tab.normalNum || tab.abNormalNum"
        :key="tabIndex"
        v-zpm="{ sortid: tab.itemId, sortname: tab.name }"
        :dataInfo="dataInfo"
        :title="tab.name"
        :tab="tab"
        :check-num-map="{
          normalNum: tab.normalNum,
          abNormalNum: tab.abNormalNum,
          allPassText: tab.allPassText,
        }"
      >
        <div
          v-if="viewImages.length && tab.isShowAbnormal == 1"
          :slot="'show'"
          class="condition-container"
        >
          <div class="new-example-pics-wrap">
            <template v-if="!detailImages.length">
              <ul class="example-pics">
                <li
                  v-for="(pic, i) in normalImages"
                  :key="i"
                  v-lazy:backgroundImage="$setPicSize(pic, 160, 160)"
                  v-zpm="{
                    sortid: i,
                    sortname: `第${i + 1}张图片`,
                    infoid: dataInfo.infoId,
                  }"
                  @click="checkBigImage(i)"
                ></li>
              </ul>
            </template>
            <template v-else>
              <div class="example-conclude-pics">
                <div
                  v-for="(pic, i) in viewImages.slice(0, 7)"
                  :key="pic"
                  v-lazy:backgroundImage="$setPicSize(pic, 160, 160)"
                  v-zpm="{
                    sortid: i,
                    sortname: `第${i + 1}张图片`,
                    infoid: dataInfo.infoId,
                  }"
                  class="img-item"
                  @click="checkBigImage(i)"
                ></div>
                <div
                  class="image-deotation"
                  :class="detailImages.length > 1 ? 'bigger' : 'smaller'"
                >
                  细节图
                  <span v-if="detailImages.length > 1">{{ `(${detailImages.length})` }}</span>
                </div>
              </div>
            </template>
          </div>
          <p v-if="tab.groupAbnormalInfo" class="tab-tips" @click="jumpFaultyAnalysisPage()">
            {{ tab.groupAbnormalInfo }}
            <span v-if="detailImages.length">，请查看细节图</span>
          </p>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <p v-if="tab.groupExplain" class="tab-desc" v-html="tab.groupExplain"></p>
        </div>

        <div slot="toggle">
          <dl v-for="(item, index) in tab.children" :key="index" class="qc-item-sec 4">
            <template v-if="item.children">
              <dt v-if="item.name" v-zpm="{ sortid: item.itemId, sortname: item.name }">
                {{ item.name }}
              </dt>
              <dd v-for="(cItem, cindex) in item.children" :key="cindex" class="cItem 44">
                <div v-for="sItem in cItem.values" :key="sItem.valueId" class="sItem">
                  <qc-item
                    v-zpm="{
                      sortid: cItem.itemId,
                      sortname: cItem.name,
                      backup: {
                        isShowPop:
                          sItem.isNormal !== 1 &&
                          (cItem.smallEncyclopediaPic ||
                            (cItem.standardDefines && cItem.standardDefines.length))
                            ? 1
                            : 0,
                      },
                    }"
                    :title="cItem.name"
                    :planIds="planIds"
                    :qcData="{
                      ...sItem,
                      groupId: tab.itemId,
                      firstItemId: item.itemId,
                      itemId: cItem.itemId, // 二级质检项id
                      smallEncyclopediaPic: cItem.smallEncyclopediaPic,
                      standardDefines: cItem.standardDefines,
                    }"
                    :item="tab.children"
                    :qcIndex="cindex"
                    :qcCode="qcCode"
                    :pageId="dataInfo.pageId || ''"
                    :cateId="cateId"
                    :indicatorGroup="indicatorGroup"
                    :reportStyle="dataInfo.report.style"
                    :infoId="dataInfo.infoId"
                    @itemClick="
                      showItem(
                        {
                          ...cItem,
                          firstItemId: item.itemId,
                        },
                        item.name
                      )
                    "
                  ></qc-item>
                  <p
                    v-if="sItem.outSideQcWiki"
                    class="qcWiki_desc new_qcWiki_desc"
                    @click="
                      showItemOutSide(
                        {
                          ...cItem,
                          firstItemId: item.itemId,
                        },
                        item.name
                      )
                    "
                  >
                    {{ sItem.outSideQcWiki }}
                  </p>
                </div>
              </dd>
            </template>
            <template v-if="item.values" class="5">
              <dd v-for="(sItem, sIndex) in item.values" :key="sItem.valueId">
                <qc-item
                  v-zpm="{ sortid: item.itemId, sortname: item.name }"
                  :title="item.name"
                  :planIds="planIds"
                  :qcData="{
                    ...sItem,
                    groupId: tab.itemId,
                  }"
                  :item="item"
                  :qcIndex="sIndex"
                  :qcCode="qcCode"
                  :pageId="dataInfo.pageId || ''"
                  :cateId="cateId"
                  :indicatorGroup="indicatorGroup"
                  :reportStyle="dataInfo.report.style"
                  :infoId="dataInfo.infoId"
                  @itemClick="showItem(item)"
                ></qc-item>
              </dd>
            </template>
          </dl>
        </div>
        <!-- 只显示异常项目 -->
        <div v-if="calculateAbnormalData(tab).length && tab.isShowAbnormal != 1" slot="antoggle">
          <template>
            <dl
              v-for="(item, index) in calculateAbnormalData(tab)"
              :key="index"
              class="qc-item-sec 6"
            >
              <dt v-if="firstTitle(item[0].title)">{{ item[0].title }}</dt>
              <dd
                v-for="(sItem, sIndex) in item"
                :key="sIndex + sItem.valueId"
                class="abnormal-show"
              >
                <qc-item
                  v-zpm="{
                    sortid: sItem.itemId,
                    sortname: sItem.name,
                    backup: {
                      isShowPop:
                        sItem.isNormal !== 1 &&
                        (sItem.smallEncyclopediaPic ||
                          (sItem.standardDefines && sItem.standardDefines.length))
                          ? 1
                          : 0,
                    },
                  }"
                  :title="sItem.name"
                  :planIds="planIds"
                  :qcData="{
                    ...sItem,
                    groupId: tab.itemId,
                  }"
                  :item="item"
                  :qcIndex="index"
                  :qcCode="qcCode"
                  :pageId="dataInfo.pageId || ''"
                  :cateId="cateId"
                  :indicatorGroup="indicatorGroup"
                  :reportStyle="dataInfo.report.style"
                  :infoId="dataInfo.infoId"
                  @itemClick="showItem(sItem)"
                ></qc-item>
                <div v-if="sItem.outSideQcWiki || sItem.urlTitle" class="new_qcWiki_desc">
                  <p v-if="sItem.outSideQcWiki" @click="showItemOutSide(sItem)">
                    {{ sItem.outSideQcWiki }}
                  </p>
                  <p v-if="sItem.urlTitle" class="tips" @click="qualityTipsClick(sItem.titleId)">
                    {{ sItem.urlTitle }}
                  </p>
                </div>
              </dd>
            </dl>
          </template>
        </div>
      </qc-report-tab>
    </template>
    <!-- 包装清单 -->
    <qc-report-tab
      v-if="dataInfo.report.packingList && dataInfo.report.packingList.length"
      title="包装清单"
      :dataInfo="dataInfo"
      :desc="`${dataInfo.report.packingList.length}项`"
    >
      <div slot="toggle">
        <dl class="qc-item-sec 444">
          <dd>
            <div v-for="(item, index) in dataInfo.report.packingList" :key="index">
              <qc-item
                v-zpm="{ sortid: `99${index}`, sortname: item.key }"
                :title="item.key"
                :planIds="planIds"
                :qcData="item"
                :qcIndex="index"
                :qcCode="qcCode"
                :pageId="dataInfo.pageId || ''"
                :cateId="cateId"
                :indicatorGroup="indicatorGroup"
                :reportStyle="dataInfo.report.style"
                :infoId="dataInfo.infoId"
                @itemClick="showItem(item)"
              ></qc-item>
            </div>
          </dd>
        </dl>
      </div>
    </qc-report-tab>
    <!-- 售后率过高问题机型的预期管理需求 增加质检解读 -->
    <div v-if="qcReportExplain" class="qc-report-unscramble">
      <div class="unscramble-list">
        <div class="unscramble_title">
          <div class="title">{{ qcReportExplain.bigTitle }}</div>
          <div
            v-if="qcReportExplain.bottomTextList && qcReportExplain.bottomTextList.length"
            class="tag"
          >
            {{ `${qcReportExplain.bottomTextList.length}项需关注` }}
          </div>
        </div>
        <div class="unscramble_list_second">
          <div
            v-for="(item, index) in qcReportExplain.bottomTextList"
            :key="index"
            class="item-unscramble"
          >
            <label>{{ item.smallTitle }}：</label>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 固定反馈入口 -->
    <section v-show="showFeedback" class="feedback-wrapper" @click="toFeedback">
      <div class="feedback-content">
        <span>以上报告内容对你有帮助吗？</span>
        <!-- https://pic3.zhuanstatic.com/zhuanzh/f21a25d9-9ace-47f2-84a7-13104b85b6bf.png -->
        <span
          ><img
            src="https://pic3.zhuanstatic.com/zhuanzh/20242b34-70b8-4d2c-b6e5-db65a7be12cf.png"
          />我要反馈</span
        >
      </div>
    </section>
  </div>
</template>
<script>
  import { PlatformBchEntry } from '@zz-common/zz-ui'
  import QcReportTab from './qc-report-tab'
  import QcItem from './qc-item'
  import { flatten, getQuery } from '../../utils/index'
  import { previewImgClick } from '../../utils/useBigImages'
  import { hasSupportFeature, isPlatform, browserLuxuryImages, skipToUrl } from '../../utils/native'
  import { getCheckBigImageList } from '../../utils/checkBigImages'
  import { setPicSize } from '@zz-common/zz-utils'
  export default {
    props: {
      dataInfo: {
        type: Object,
        default: () => {},
      },
      qcCode: {
        type: String,
        default: () => '',
      },
      fromMicroDetail: {
        type: Boolean,
        default: false,
      },
      warehouseInfo: {
        type: String,
        default: '',
      },
      showFeedback: {
        type: Boolean,
        default: false,
      },
      feedbackData: {
        type: Object,
        default: () => {},
      },
      cateId: {
        type: Number,
        default: 0,
      },
      planIds: {
        type: String,
        default: '',
      },
    },
    components: {
      QcReportTab,
      QcItem,
      [PlatformBchEntry.name]: PlatformBchEntry,
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
      indicatorGroup() {
        const group = []
        //实拍图原图集合
        const pics = (this.dataInfo.report && this.dataInfo.report.samplePics) || []
        if (pics && pics.length) {
          group.unshift({
            title: '实拍图',
            subtitle: '概况',
            total: pics.length,
            data: pics,
          })
        }

        // 采货侠, 订单快照、微商详质检报告场景, 不会从父组件传瑕疵图过来, 需要在本组件组装瑕疵图数据
        // if (!this.dataInfo.detailDrawing) {
        //   data = this.collectFlawedImg()
        // } else {
        //   //一机一拍商详场景下瑕疵图数据, 直接从父组件传过来, 具体逻辑在streamline_detail/home.vue
        //   data = {
        //     detailDrawing: this.dataInfo.detailDrawing,
        //     detailDrawingIds: this.dataInfo.detailDrawingIds,
        //     detailDrawingNewObj: this.dataInfo.detailDrawingNewObj,
        //   }
        // }

        // 瑕疵图相关数据全部在组件内部计算
        const data = this.collectFlawedImg()
        if (Object.keys(data).length) {
          const { detailDrawingIds = {}, detailDrawingNewObj = [], viewImagesList = [] } = data
          const detailDrawed = detailDrawingNewObj.map((item) => item.url) || []
          group.push({
            title: '细节图',
            subtitle: '细节',
            total: detailDrawed.length,
            data: detailDrawed,
            imgDataList: detailDrawingNewObj,
            itemIds: detailDrawingIds,
            viewImagesList,
          })
        }
        return group
      },

      firstReportItem() {
        const tempItem = this.dataInfo.report.reportItem[0].children[0].children[0]
        const tab = this.dataInfo.report.reportItem[0]
        const obj = {
          ...tempItem.values[0],
          groupId: tab.itemId,
          firstItemId: tab.children[0].itemId,
          secondItemId: tempItem.itemId,
          thirdItemId: tempItem.values[0].valueId,
          isNormal: tempItem.values[0].isNormal,
          infoId: this.dataInfo.infoId,
          cateID: this.cateId,
        }
        return obj
      },

      viewImages() {
        const allImages = this.collectFlawedImg()
        console.log([allImages.viewImagesList[0], ...this.dataInfo.report.samplePicIds], 'teste')
        return [allImages.viewImagesList[0], ...this.dataInfo.report.samplePicIds]
      },

      // 细节图
      detailImages() {
        const allImages = this.collectFlawedImg()
        console.log([...allImages.viewImagesList], '[...allImages.viewImagesList]')
        return [...allImages.viewImagesList]
      },

      // 实拍图
      normalImages() {
        return [...this.dataInfo.report.samplePicIds]
      },
      // viewImages() {
      //   const indicatorGroups = JSON.parse(JSON.stringify(this.indicatorGroup))
      //   indicatorGroups.forEach((item) => {
      //     if (item.title === '细节图') {
      //       if (item.isNotShowDetail) {
      //         //删除最后一张配件清单
      //         item.data.pop()
      //       }
      //     }
      //   })
      //   const allImages = flatten(indicatorGroups.map((item) => item.data))
      //   return allImages
      // },

      videoVos() {
        const videoVos =
          this.dataInfo.videoList && this.dataInfo.videoList.length
            ? this.dataInfo.videoList[0]
            : { url: '' }
        return videoVos
      },

      // $ 质检报告解读文案
      qcReportExplain() {
        return (this.dataInfo.report && this.dataInfo.report.qcReportExplain) || null
      },
    },
    methods: {
      // $ 查看质检项
      showItem(data, currentTitle) {
        this.$emit('toggle', {
          ...data,
          newValue: data.value,
          firstItemId: data.firstItemId,
          standardDefines: data.standardDefines || [],
          title: currentTitle || data.title,
          smallEncyclopediaPic: data.smallEncyclopediaPic || '',
        })
      },

      jumpFaultyAnalysisPage() {
        const { firstItemId, secondItemId, thirdItemId, groupId, isNormal, infoId } =
          this.firstReportItem
        const cateId = this.cateId
        console.log(isNormal, 'isNormal', infoId, 'infoId')
        const saleCombineIds = getQuery('saleCombineIds')
        if (!infoId) return
        const targetUrl = `https://m.zhuanzhuan.com/u/b2c_one_page_bizs/faultyAnalysis.html?platformType=zz&bgARGB=FF000000&needHideHead=3${
          saleCombineIds ? '&saleCombineIds=1' : ''
        }&infoId=${infoId}&pgCateId=${cateId}&groupId=${groupId}&firstItemId=${firstItemId}&secondItemId=${secondItemId}&thirdItemId=${thirdItemId}`
        window.parent.postMessage(`checkMoreReport=${targetUrl}`, '*')
        skipToUrl({
          targetUrl,
        })
      },
      // $ 百科外置说明点击
      showItemOutSide(data, currentTitle) {
        if (!(data.smallEncyclopediaPic || (data.standardDefines && data.standardDefines.length)))
          return false
        if (data.notToast == 1) return false
        this.$emit('toggle', {
          ...data,
          newValue: data.value,
          firstItemId: data.firstItemId,
          standardDefines: data.standardDefines || [],
          title: currentTitle || data.title,
          smallEncyclopediaPic: data.smallEncyclopediaPic || '',
          otherText: '外置',
        })
      },

      sliceText(str) {
        const leftIndex = str.indexOf('<')
        if (leftIndex !== -1) {
          const text = str.slice(0, leftIndex)
          str = this.sub(str, leftIndex)
          return text
        }
      },

      sliceHtml(str) {
        const leftIndex = str.indexOf('<')
        const rightIndex = str.indexOf('>')
        if (leftIndex !== -1 && rightIndex !== -1) {
          const text = str.slice(leftIndex, rightIndex + 1)
          str = this.sub(str, rightIndex + 1)
          return text
        }
      },

      sub(str, substr) {
        if (substr) {
          return str.substr(substr.length)
        }
        return str
      },

      //查看大图
      checkBigImage(selectedIndex) {
        let indicatorGroup = JSON.parse(JSON.stringify(this.indicatorGroup))
        const reportItem = this.dataInfo.report && this.dataInfo.report.reportItem
        const bottomTips = []

        indicatorGroup.forEach((item) => {
          if (item.title === '细节图') {
            // 过滤掉不需要展示的细节图
            const newobj = item.imgDataList && item.imgDataList.filter((i) => i.notShowDetail == 0)
            // 过滤掉对应的细节图id
            const ids =
              item.imgDataList &&
              item.imgDataList
                .map((i, index) => {
                  if (i.notShowDetail == 1) return index
                })
                .filter(Boolean)

            //删除瑕疵图对应一二三级质检项的id
            ids.forEach((i) => {
              delete item.itemIds[i]
            })
            item.imgDataList = newobj
            // 获取瑕疵图原图集合
            const newViewImagesList = item.imgDataList.map((i) => i.url)
            item.data = newViewImagesList
          }
        })
        // 翻转数组 细节图在前 实拍图在后
        indicatorGroup = indicatorGroup.reverse()
        // 实拍图+瑕疵图原图集合
        const picAndDefectImages = flatten(indicatorGroup.map((item) => item.data) || [])
        //判断是否有视频
        const videoVos =
          this.dataInfo.videoList && this.dataInfo.videoList.length
            ? this.dataInfo.videoList[0]
            : []

        //第一张实拍图
        const firstSamplePicIdsImage = picAndDefectImages[0] || ''

        const imgArr = videoVos.length
          ? [firstSamplePicIdsImage, ...picAndDefectImages]
          : picAndDefectImages

        const tabList = getCheckBigImageList({
          indicatorGroup: indicatorGroup,
          qcCode: this.qcCode,
        })

        console.log(tabList, 'tabList1')
        console.log(indicatorGroup, 'indicatorGroup')

        if (reportItem) {
          let { groupExplain = '' } = reportItem[0]

          let isBold = 0
          if (groupExplain && groupExplain.indexOf('<') !== -1) {
            while (groupExplain) {
              // 截取字符串
              const leftText = this.sliceText(groupExplain)
              if (leftText) {
                bottomTips.push({
                  isBold,
                  text: leftText,
                })
              }

              groupExplain = this.sub(groupExplain, leftText)
              const lHtml = this.sliceHtml(groupExplain)
              isBold = isBold === 1 ? 0 : 1
              groupExplain = this.sub(groupExplain, lHtml)
            }
          } else {
            bottomTips.push({
              isBold: 0,
              text: groupExplain,
            })
          }

          // console.log(bottomTips, 'bottomTips')
          tabList.forEach((item) => {
            item.bottomTips = bottomTips
          })
        }

        console.log(tabList, 'tabList')
        // 匹配索引位置
        if (this.detailImages.length) {
          selectedIndex =
            selectedIndex === 0 ? selectedIndex : selectedIndex + this.detailImages.length - 1
        }

        const goodsMsg = {
          goodsAddress: this.warehouseInfo || '',
          goodsNumber: this.qcCode ? `验机编码 ${this.qcCode}` : '',
        }

        if (isPlatform('zz') && !videoVos.length) {
          hasSupportFeature({ method: 'browserLuxuryImages' }, (res) => {
            if (res && res.code && res.code != '-1') {
              browserLuxuryImages({
                selectedIndex,
                tabList,
                ...goodsMsg,
                needSlideCallback: 1,
                zpmPageId: this.dataInfo.pageId,
              })
            } else {
              previewImgClick(imgArr, videoVos, selectedIndex)
            }
          })
        } else {
          window.parent.postMessage(`imageUrl=${imgArr[selectedIndex]}`, '*')
          previewImgClick(imgArr, videoVos, selectedIndex)
        }
      },

      calculateAbnormalData(original_arr, result = []) {
        const arr = original_arr.children || []
        if (!arr) return
        arr.forEach((item) => {
          if (item.values) {
            item.values.forEach((i) => {
              if (i.isNormal !== 1 || i.isOpenShow === 1) {
                result.push({
                  ...i,
                  ...item,
                  firstItemId: original_arr.itemId,
                  name: item.name,
                  img: '666',
                  title: original_arr.name,
                })
              }
            })
          }
          if (item.children) {
            this.calculateAbnormalData(item, result)
          }
        })
        const s = new Set() //实例化对象
        result.forEach((item) => s.add(item.firstItemId)) // $ 添加值（Set可以去掉重复数据）
        const newData = Array.from({ length: s.size }, () => []) // $ 创建指定长度数组并添值
        result.forEach((item) => {
          const index = [...s].indexOf(item.firstItemId) // $ 找到指定下标
          newData[index].push(item) // $ 添加数据
        })
        return newData
      },

      firstTitle(data) {
        if (!this.dataInfo.report.showSecondItemNameList) return ''
        return this.dataInfo.report.showSecondItemNameList.find((item) => item === data) || ''
      },

      //获取瑕疵图
      /**
       * @description: 递归遍历获取瑕疵图
       * @param {*} objectTree 遍历的对象
       * @param {*} childrenName 递归的属性名
       * @param {*} targetTree 递归的目标对象
       * @param {*} targetNode 递归的目标对象里面的目标值
       * @param {*} detailDrawing 目标值存储的数组
       * @param {*} viewImagesList notShowDetail为false的时候收集，外观检测预览的时候用到
       * @return {*}
       */
      collectAllFlawedImg(
        originTree,
        childrenName,
        targetTree,
        targetNode,
        collection,
        valueIds,
        detailDrawingNewObj,
        viewImagesList
      ) {
        originTree.forEach((item, index) => {
          if (item[targetTree]) {
            item[targetTree].map((z) => {
              if (!z.notShowDetail && z[targetNode] && z[targetNode].length > 0) {
                z[targetNode].forEach((item) => {
                  viewImagesList.push(item.imgUrl)
                })
              }

              const sItem =
                item.standardDefines &&
                item.standardDefines.length &&
                item.standardDefines.find((sItem) => sItem.qcItemName === z.value) // 获取当前百科数据 客户端预览大图需要用到此数据
              const flawDesc = sItem && sItem.defineDesc && sItem.defineDesc[0]
              // 单瑕疵图多拍
              // 以下是瑕疵图的逻辑
              if (z[targetNode] && z[targetNode].length > 0) {
                z[targetNode].forEach((img) => {
                  collection.push(item.itemId)
                  valueIds.push(z.valueId)
                  detailDrawingNewObj.push({
                    flawTitle: `${item.firstTitle}-${item.name}-${z.value}`,
                    flawDesc: flawDesc || '',
                    url: img.origImgUrl,
                    notShowDetail: z.notShowDetail ? 1 : 0, //判断是否要展示到外观检测轮播图
                  })
                })
              }
            })
            return
          }
          if (item[childrenName]) {
            this.collectAllFlawedImg(
              item[childrenName],
              childrenName,
              targetTree,
              targetNode,
              collection,
              valueIds,
              detailDrawingNewObj,
              viewImagesList
            )
          }
        })
      },

      treeFindPath(tree, func, path = []) {
        if (!tree) return []
        for (const data of tree) {
          path.push(data.itemId)
          if (func(data)) return path
          if (data.children) {
            const findChildren = this.treeFindPath(data.children, func, path)
            if (findChildren.length) return findChildren
          }
          path.pop()
        }
        return []
      },

      // 获取瑕疵图
      // 适用场景： 微商详|订单快照质检报告，不用从外部传瑕疵图相关数据，直接组件内部封装好，只传接口数据即可
      collectFlawedImg() {
        const reportItem = this.dataInfo.report && this.dataInfo.report.reportItem
        const collectArr = []
        const valueIds = []
        const detailDrawingNewObj = [] // $ 存放客户端大图预览的细节图对象
        const viewImagesList = []

        if (reportItem) {
          reportItem.forEach((originTreeItem, originTreeIdex) => {
            if (originTreeItem.children) {
              // console.log(originTreeIdex, originTreeItem.children)
              originTreeItem.children.forEach((mapItem, mapIndex) => {
                mapItem.children &&
                  mapItem.children.forEach((zItem) => {
                    zItem.firstTitle = mapItem.name || ''
                  })
              })
            }
          })
          this.collectAllFlawedImg(
            reportItem,
            'children',
            'values',
            'flawedImgVo',
            collectArr,
            valueIds,
            detailDrawingNewObj,
            viewImagesList
          )
        }
        const collectObj = {}
        if (collectArr.length) {
          for (let i = 0; i < collectArr.length; i++) {
            collectObj[i] = this.treeFindPath(reportItem, (data) => data.itemId == collectArr[i])
            collectObj[i].push(valueIds[i])
            collectObj[i].shift()
          }
        }
        return {
          detailDrawingIds: collectObj,
          detailDrawingNewObj: detailDrawingNewObj,
          viewImagesList: viewImagesList,
        }
      },
      qualityTipsClick(titleId) {
        this.$emit('qualityTipsClick', { isPoup: true, titleId })
      },
      //去反馈
      toFeedback() {
        const extend = { pageName: '验机报告', ...this.feedbackData }
        let targetUrl = `https://m.zhuanzhuan.com/common/uem/index.html?needHideHead=3&hiddenProgress=1&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8&questionnaireId=1647865782358511616&extend=${encodeURIComponent(
          JSON.stringify(extend)
        )}#/question-bch`
        if (isPlatform('zz')) {
          targetUrl = `zhuanzhuan://jump/core/web/jump?url=${encodeURIComponent(targetUrl)}`
        }
        skipToUrl({
          targetUrl,
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  @import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';
  .new-qc-report-detail {
    margin-top: 22px;
    padding: 0 24px 32px;
    border-radius: 16px;
    background: #fff;
    .qc-report-unscramble {
      margin: 49px 0 0;
      .unscramble-list {
        padding: 42px 0 0;
        box-sizing: border-box;
        position: relative;
        &::after {
          @include hairline(#d8d8d8);
          border-top-width: 1px;
          border-top-style: dashed;
        }
        .unscramble_title {
          display: flex;
          align-items: center;
          margin-bottom: 28px;
          .title {
            max-width: 75%;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000;
            line-height: 28px;
            @include ellipsis();
          }
          .tag {
            margin-left: 8px;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffae3c;
            padding: 8px 12px;
            box-sizing: border-box;
            @include border-1px(#ffae3c, 8px);
          }
        }
        .unscramble_list_second {
          background: #f7f7f7;
          border-radius: 4px;
          padding: 20px 24px;
          box-sizing: border-box;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 34px;
          max-height: 115px;
          overflow-y: scroll;
          // &::-webkit-scrollbar {
          //   display: none;
          // }
          .item-unscramble:not(:last-child) {
            margin-bottom: 8px;
          }
          label {
            color: #111111;
          }
          span {
            color: #999;
          }
        }
      }
    }
    .new-example-pics-wrap {
      position: relative;
      margin-top: 19px;
    }
    .tab-tips {
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: #666;
      line-height: 28px;
      margin-top: 13px;
    }
    .tab-desc {
      display: inline-block;
      width: 100%;
      margin-top: 16px;
      background: #fafafa;
      border-radius: 4px;
      padding: 14px 20px 14px 20px;
      box-sizing: border-box;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: #666;
      line-height: 30px;
      text-align: justify;
    }
    ul.example-pics {
      font-size: 0;
      position: relative;
      top: -10px;
      width: 600px;
      // white-space: nowrap;
      // overflow-x: auto;
      // -webkit-overflow-scrolling: touch;
      // padding: 5px 0;
      li {
        display: inline-block;
        width: 111px;
        height: 112px;
        margin-top: 10px;
        margin-right: 10px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 4px;
      }
      li:last-child {
        margin-right: 0;
      }
      li:nth-child(5n) {
        margin-right: 0;
      }
    }

    .example-conclude-pics {
      width: 600px;
      font-size: 0;
      padding: 5px 0;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 10px;
      .img-item {
        display: inline-block;
        width: 112px;
        height: 112px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 4px;
      }
      .img-item:first-child {
        width: 234px;
        height: 234px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 4px;
        grid-column: 1 / 3;
        grid-row: 1 / 3;
      }
      .image-deotation {
        background: rgba(255, 255, 255, 0.6);
        border-radius: 0px 4px 0px 4px;
        position: absolute;
        top: 4px;
        left: 132px;
        font-size: 20px;
        font-weight: 300;
        color: #111111;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .bigger {
        width: 102px;
        height: 36px;
      }
      .smaller {
        width: 76px;
        height: 36px;
        left: 160px;
      }
    }

    dl.qc-item-sec {
      line-height: 20px;
      color: #999;
      font-size: 20px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      dt {
        margin-bottom: 24px;
        color: #111;
      }
      dd {
        margin-bottom: 24px;
      }
      dd.abnormal-show {
        // margin-top: 8px;
        div:last-child {
          margin-bottom: 0 !important;
        }
      }
    }
    dl.qc-item-sec:first-child {
      padding-top: 24px;
    }
    dl.qc-item-sec:last-child {
      dd:last-child {
        margin-bottom: 0;
        .sItem:last-child {
          .value-item {
            margin-bottom: 0;
          }
        }
      }
    }
    .new_qcWiki_desc {
      padding: 14px 18px;
      background: #f7f7f7;
      border-radius: 4px;
      font-size: 20px;
      font-weight: 300;
      font-family: PingFangSC-Light, PingFang SC;
      color: #999;
      line-height: 28px;
      margin-bottom: 32px !important;
      .tips {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #42a0ff;
        line-height: 20px;
        margin-top: 16px;
      }
    }
    .content-wrap-antoggle {
      .qc-item-sec:last-child {
        .qcWiki_desc {
          margin-bottom: 0 !important;
        }
      }
    }
    .error_item_title {
      margin-bottom: 24px;
      color: #111;
    }

    .feedback-wrapper {
      padding-top: 30px;

      .feedback-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        left: -24px;
        width: 646px;
        margin-bottom: -2px;
        padding: 30px 29px 0 24px;
        font-size: 24px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: #111111;
        box-sizing: border-box;

        &::after {
          @include hairline(#f0f0f0);
          border-top-width: 1px;
        }
        span {
          display: flex;
          align-items: center;
        }
        img {
          margin-right: 6px;
          width: 24px;
          height: 24px;
        }
      }
    }
  }
</style>
